import { IonChip } from "@ionic/react";
import React from "react";

export type SaveStatusState = "unsaved" | "saving" | "saved" | undefined;

interface EntryCardSaveStatusChipProps {
    stateValue: SaveStatusState;
}

const EntryCardSaveStatusChip: React.FC<EntryCardSaveStatusChipProps> = ({ stateValue }) => {
    return (
        <IonChip className={`bg-${stateValue === "saving" ? "info" : stateValue === "saved" ? "success" : "medium"} text-white m-0 mt-2 mr-2`}>
            {stateValue === "saving" ? "Saving..." : stateValue === "saved" ? "Saved" : "Unsaved"}
        </IonChip>
    );
};

export default EntryCardSaveStatusChip;
